import { withInstall } from '@xzx-design/utils'
import _Badge from './src/badge'

export const Badge = withInstall(_Badge)
export default Badge

export * from './src/badge'
export * from './src/types'
